"use strict";

import "vwa/reset.css";

import "babel-polyfill";
import React						from "react";
import ReactDOM						from "react-dom";
import Dashboard					from "./view/Dashboard";

window.onload = () => {
	ReactDOM.render(
		<Dashboard ref={ref => window.app = ref}/>,
		document.querySelector("#appContainer")
	);
};


// WEBPACK FOOTER //
// ./src/app.jsx